import React from 'react';
import { CardWrapper } from './SubscriptionComponentCard.styles';
import { SubscriptionComponentCardVariants } from './types';

export type Props = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Distance between rows inside card
   */
  rowGap?: number;
  /**
   * Card variant
   */
  variant?: SubscriptionComponentCardVariants;
};

const SubscriptionComponentCard = ({
  children,
  rowGap = 2,
  variant = 'primary',
}: Props) => (
  <CardWrapper
    borderRadius={3}
    padding={4}
    gridRowGap={rowGap}
    variant={variant}
    data-testid="card"
  >
    {children}
  </CardWrapper>
);

export default SubscriptionComponentCard;
